<template>
  <div>
    <div class="resume-documents__head-subtitle">{{ answer.show_status.value }}</div>

    <div
      v-for="(file, index) in answer.files"
      :key="index"
      class="mt-3"
    >
      <div>{{ file.name.name }}: {{ file.name.value }}</div>
      <div>{{ file.type.name }}: {{ file.type.value }}</div>
      <div v-if="file.path.value">
        <div>{{ file.path.name }}:</div>
        <img
          style="width: 12rem; height: 7rem; object-fit: cover"
          :src="file.path.value"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CertificatesAnswer',
  props: {
    answer: {
      type: Object,
      required: true,
    },
  },
};
</script>
